import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";
import redirectionArrow from "./redirectionArrow.svg";

function ProjectRedirection(props: Props) {
  const { t } = useTranslation();

  return (
    <Link
      className={styles.redirectButton}
      to={`/projects/${props.projectId}`}
      onClick={(e) => {
        if (!e.metaKey && !e.ctrlKey) {
          props.close();
        }
      }}
    >
      <img className={styles.icon} src={redirectionArrow} />
      <h3 className={classNames(styles.contentButton, props.className)}>
        {t("projectDetails.redirectProject")}
      </h3>
    </Link>
  );
}

export { ProjectRedirection };
